import { render } from "./FloatingLabel.vue?vue&type=template&id=264da160"
import script from "./FloatingLabel.vue?vue&type=script&lang=js"
export * from "./FloatingLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__